import { useState } from "react";
import { Copy, Link as LinkIcon, Check, Send } from "lucide-react";
import { getTitulo, getTexto } from "@/lib/salmos";
import { useLang } from "@/lib/i18n";

export default function BotaoPartilhar({ salmo }) {
  const [copiado, setCopiado] = useState(false);
  const [linkCopiado, setLinkCopiado] = useState(false);
  const { lang, t } = useLang();

  const url = typeof window !== "undefined" ? `${window.location.origin}/salmo/${salmo.numero}` : "";
  const textoPartilha = `${t.salmo} ${salmo.numero} — ${getTitulo(salmo, lang)}\n\n${getTexto(salmo, lang)}\n\n— salmos.pt`;

  const copiarTexto = async () => {
    try {
      await navigator.clipboard.writeText(textoPartilha);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {}
  };
  const copiarLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setLinkCopiado(true);
      setTimeout(() => setLinkCopiado(false), 2000);
    } catch {}
  };
  const whatsapp = () => {
    const msg = encodeURIComponent(`${textoPartilha}\n\n${url}`);
    window.open(`https://wa.me/?text=${msg}`, "_blank");
  };

  const btn = "flex items-center gap-2 font-display text-xs uppercase tracking-[0.22em] text-[var(--cor-texto-2)] border border-[var(--cor-borda)] px-5 py-3 rounded-full hover:border-[var(--cor-dourado)]/50 hover:text-[var(--cor-dourado-claro)] transition-all duration-300";

  return (
    <div className="flex flex-wrap gap-3 justify-center" data-testid="botoes-partilhar">
      <button onClick={copiarTexto} className={btn} data-testid="copiar-texto-btn">
        {copiado ? <Check className="h-4 w-4 text-[var(--cor-dourado-claro)]" /> : <Copy className="h-4 w-4" />}
        {copiado ? t.copiado : t.copiar_texto}
      </button>
      <button onClick={whatsapp} className={btn} data-testid="whatsapp-btn">
        <Send className="h-4 w-4" />
        WhatsApp
      </button>
      <button onClick={copiarLink} className={btn} data-testid="copiar-link-btn">
        {linkCopiado ? <Check className="h-4 w-4 text-[var(--cor-dourado-claro)]" /> : <LinkIcon className="h-4 w-4" />}
        {linkCopiado ? t.link_copiado : t.copiar_link}
      </button>
    </div>
  );
}
